import { RootState } from '@/App/store';

export const selectChangePassword = (state: RootState) => state.changePassword;
